import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import isSpa from "shared/util/isSpa";
import Link from "shared/components/Link";
import Str from "shared/components/Str";
import {
	selectedOptionOnNavBarEvent,
} from "./analytics";
import LikesIcon from "./icons/Likes.svg";

const LikesLink = ({ isSelected, likesCount }) => (
	<Link
		to="/who-likes-you"
		className="navbar-link"
		id="nav_ratings"
		onClick={() => {
			selectedOptionOnNavBarEvent("Likes");
		}}
		noSpa={!isSpa()}
	>
		<div className="navbar-link-icon-container" >
			<LikesIcon
				className={classnames("navbar-icon", {
					"navbar-icon-selected": isSelected,
				})}
				width={24}
				height={24}
			/>
			{/**
				The likesCount can be jQuery-ed in via InstantEvents
				need id="navbar-ratings", nav_ratings_badge
				& span, className="count".
			*/}
			<div id={likesCount !== null ? "" : "navbar-ratings"}>
				{
					likesCount
						? (
							<div className="navbar-likes-count">
								<span className="count">
									{likesCount > 99 ? "99+" : likesCount}
								</span>
							</div>
						)
						: null
				}
			</div>
			<div
				className={classnames("navbar-underline", {
					"navbar-underline-selected": isSelected,
				})}
			/>
		</div>
		<span className="navbar-text">
			<Str>Likes</Str>
		</span>
	</Link>
);

LikesLink.defaultProps = {
	isSelected: false,
	likesCount: null,
};


LikesLink.propTypes = {
	isSelected: PropTypes.bool,
	likesCount: PropTypes.number,
};

export default LikesLink;



// WEBPACK FOOTER //
// ./src/shared/components/NavBar/LikesLink.jsx